import { useCallback, useEffect, useRef } from 'react';

/**
 * Create a promise wrapper that will only resolve/reject if component is still mounted
 */
export const usePromise = () => {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return useCallback(
    <T>(promise: Promise<T>) =>
      new Promise<T>((resolve, reject) => {
        const onValue = (value: T) => {
          isMountedRef.current && resolve(value);
        };
        const onError = (error: T) => {
          isMountedRef.current && reject(error);
        };
        promise.then(onValue, onError);
      }),
    []
  );
};
